var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "LoginPane" }, [
    _c("div", { staticClass: "title-wrap" }, [
      _c("img", {
        attrs: { src: require("@/assets/image/logo.jpg"), alt: "" }
      }),
      _c("span", [_vm._v(_vm._s(_vm.$t("page.login.title")))])
    ]),
    _c(
      "div",
      { staticClass: "form-wrap" },
      [
        _c(
          "el-form",
          {
            ref: "loginForm",
            attrs: { model: _vm.loginForm, rules: _vm.loginFormRules }
          },
          [
            _c(
              "el-form-item",
              { attrs: { prop: "username" } },
              [
                _c(
                  "el-input",
                  {
                    attrs: {
                      type: "text",
                      placeholder: _vm.$t("page.login.placeholder.username")
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "username", $$v)
                      },
                      expression: "loginForm.username"
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-user",
                      attrs: { slot: "prefix" },
                      slot: "prefix"
                    })
                  ]
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { prop: "password" } },
              [
                _c(
                  "el-input",
                  {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("page.login.placeholder.password")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleLogin.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "password", $$v)
                      },
                      expression: "loginForm.password"
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-lock",
                      attrs: { slot: "prefix" },
                      slot: "prefix"
                    })
                  ]
                )
              ],
              1
            ),
            _vm.isShowCaptcha
              ? _c(
                  "div",
                  { staticClass: "captchaItem" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "captcha" } },
                      [
                        _c("el-input", {
                          staticClass: "captcha",
                          staticStyle: { width: "190px" },
                          attrs: {
                            placeholder: _vm.$t(
                              "page.login.placeholder.verification"
                            )
                          },
                          model: {
                            value: _vm.loginForm.CaptchaCode,
                            callback: function($$v) {
                              _vm.$set(_vm.loginForm, "CaptchaCode", $$v)
                            },
                            expression: "loginForm.CaptchaCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c("img", {
                      attrs: { src: _vm.captchaImage },
                      on: { click: _vm.handleCaptchaImage }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "btn-wrap" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", loading: _vm.btnLoading },
            on: { click: _vm.handleLogin }
          },
          [_vm._v(_vm._s(_vm.$t("page.login.button.login")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }